export default __webpack_public_path__ + "static/media/Jerkin of Clawing Might.eb6cbe30.jpg";